export const dateBannerClasses = `
    bg-modal-overlay
    mb-9
`
